import * as S from './LandingPageLoggedOut.style';
import { Button, Typography } from '@mui/material';
import tailorLogo from 'logos/tailor.svg';

import { signInWithRedirect } from 'aws-amplify/auth';

export default function LandingPageLoggedOut() {
  return (
    <S.Page>
      <div className="wrapper-restrict-width">
        <main>
          <img className="logo" alt="Tailor" src={tailorLogo} />
          <Typography variant="h6" component="p" sx={{ mt: 2, color: 'text.secondary' }}>
            Entail's automation platform
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => signInWithRedirect()}
            sx={{
              mt: 8,
              minWidth: 160,
              minHeight: 48,
              fontWeight: 600,
              letterSpacing: 1.25,
            }}
          >
            Log in
          </Button>
        </main>
        <footer>
          <p>
            © <a href="https://www.entail.no">Entail AS</a>
          </p>
        </footer>
      </div>
    </S.Page>
  );
}
